import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
// Raw API response from POST /invoice/v1/customers/{customerId}/autoplan/check
export interface AutoplanCheckResponse {
  bestPlanName: string;
  currentPlanName: string;
  currentAutoPlan: boolean;
  calculatedPlanList: ApiCalculatedPlan[];
}

export interface ApiCalculatedPlan {
  planName: string;
  level: number;
  totalSum: number;
  totalBasicFeeSum: number;
  totalServiceFeeSum: number;
  extensionList: ApiExtension[];
  featureList: ApiPlanFeature[];
}

export interface ApiExtension {
  name: string;
  booked: boolean;
  showName: string;
}

export interface ApiPlanFeature {
  key: string;
  showName: string;
  amount: number;
  price: number;
  totalSum: number;
}

@Injectable({ providedIn: 'root' })
export class TariffCheckService {
  private readonly http = inject(HttpClient);

  checkAutoplan(
    customerId: number,
    includedExtensions: string[],
    excludedExtensions: string[]
  ): Observable<AutoplanCheckResponse> {
    const params: Record<string, string> = {};
    if (includedExtensions.length > 0) {
      params['includedExtensions'] = includedExtensions.join(',');
    }
    if (excludedExtensions.length > 0) {
      params['excludedExtensions'] = excludedExtensions.join(',');
    }

    return this.http.post<AutoplanCheckResponse>(
      `${environment.invoiceUrl}/customers/${customerId}/autoplan/check`,
      null,
      { params }
    );
  }
}
